var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarehouse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H8V21H6V19ZM12 3L2 8V21H4V13H20V21H22V8L12 3ZM8 11H4V9H8V11ZM14 11H10V9H14V11ZM20 11H16V9H20V11ZM6 15H8V17H6V15ZM10 15H12V17H10V15ZM10 19H12V21H10V19ZM14 19H16V21H14V19Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarehouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warehouse.bc7123248d041156de83265943261b1c.svg";